import { useLanguageContext } from "../../../context/LanguageContext";
import ParkingLocationPage from "../../../pages/parking_locations/parking_location/ParkingLocationPage";
import { useParkingLocationCreateRouteValidator } from "../../validators/parking_locations/ParkingLocationCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useParkingLocationsRouteConfig from "./ParkingLocationsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useParkingLocationCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/parking_locations/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.parking_location"),
        },
      ])
    )
    .setValidator(useParkingLocationCreateRouteValidator())
    .setPage(<ParkingLocationPage />)
    .setParent(useParkingLocationsRouteConfig());
}

export default useParkingLocationCreateRouteConfig;
